<script>
  import { Checkbox } from '@shopboxai/sb-portal-components';
  export let name = '';
  export let valueMobile = false;
  export let valueDesktop = false;
</script>

<p class="feature-name">
  {name}
  <span>
    <Checkbox on:input bind:value={valueMobile} />
    <span class="separator" />
    <Checkbox on:input bind:value={valueDesktop} />
  </span>
</p>

<style>
  .feature-name {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: var(--t-c-l);
    margin-bottom: 1em;
  }
  .feature-name > span {
    display: flex;
    justify-content: space-around;
    width: 100px;
  }
  .separator {
    height: 12px;
    width: 1px;
    margin: auto 0;
    background-color: #d9d9d9;
  }
</style>
